import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import _ from "underscore";
import { apiPromiseHook } from "../../../shared/flux/actions/enterHooks";
import * as StringUtil from "../../../shared/helpers/stringHelpers";
import { EnterHookPromises } from "../../state/enterHookPromises";
import { Loader, StarRating } from "./../../../core/atoms/atoms";
import { Nav, NavLink } from "./../../../core/organisms/nav";
import { HeroSection } from "@travellocal/ui";
import { RoutesInvoker } from "./../../routesInvoker";

import "./lto.scss";

interface StateProps {
  lto: IState<ILto>;
}

type Props = StateProps;

const mapStateToProps = (state: IWebStoreState): StateProps => {
  return {
    lto: state.lto,
  };
};

export class LtoIndexComponent extends React.Component<Props, {}> {

  public render() {
    if (this.props.lto.status !== "OK") {
      return <Loader/>;
    }

    const lto = this.props.lto.data;
    const ltoCountries = lto.locations.filter(l => l.locationType === LocationType.Country && l.locationStatus === LocationStatus.Live);
    const featuredCountry = ltoCountries.length > 0 ? ltoCountries[0] : null;
    const heroImage = featuredCountry && featuredCountry.heroImage ? featuredCountry.heroImage : null;
    const reviewCount = lto.reviewSummary.count;
    const ltoDisplayName = lto.publicName || lto.name;
    const ltoDisplaySpeciality = lto.publicSpeciality || lto.speciality;

    return (
      <div className="lto-index">
        <Helmet
          title={lto.titleTag || StringUtil.capitalize(ltoDisplayName)}
          meta={[
            { name: "description", content: lto.descriptionTag && lto.descriptionTag.length > 1 ? lto.descriptionTag : ltoDisplaySpeciality },
          ]}
        />

        <HeroSection heroImage={heroImage}>
          {reviewCount > 0 &&
            <div>
              <StarRating currentValue={lto.reviewSummary.overallRating} maximumValue={5} title={`Average customer rating: ${lto.reviewSummary.overallRating}/5`} />
            </div>
          }
          <h1>{StringUtil.capitalize(ltoDisplayName)}</h1>
        </HeroSection>

        <Nav className="nav-marketing-inline">
          <NavLink to={RoutesInvoker.lto(lto.slug)} title="Overview" onlyActiveOnIndex={true} />
        </Nav>

        {this.props.children}
      </div>
    );
  }
}

export const LtoIndex = connect(mapStateToProps)(LtoIndexComponent);
export const ltoIndexOnEnter = apiPromiseHook(EnterHookPromises.ltoBySlug());
